








import { computed, defineComponent } from '@nuxtjs/composition-api';
import { useCartView } from '~/composables';
import EvidenceProducts from '~/components/solepro/EvidenceProducts.vue';
import useTemporizedCart from '~/composables/useTemporizedCart';
import useLoader from '~/composables/useLoader';
import ClientOnly from 'vue-client-only'

export default defineComponent({
    name: 'CartPage',
    layout: '24orepro',
    components: {
        ClientOnly,
        EvidenceProducts
    },
    setup() {

        const { products: cartItems, loading } = useCartView();
        const { deletedProducts } = useTemporizedCart();
        const { setIsLoading } = useLoader();

        const CartComponent = computed(() => (cartItems.value && cartItems.value.length > 0) || deletedProducts.value.length > 0 ? () => import('~/components/solepro/Cart/Cart.vue') : () => import('~/components/solepro/Cart/EmptyCart.vue'))
        return {
            CartComponent,
            loading,
            setIsLoading
        }
    },
    watch: {
        loading(newVal) {
            this.setIsLoading(newVal)
        }
    }
})
